import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";

/** Selects the complete single-page Split Costing import experience. */
export function useSplitCostingClusteredReportEnabled(): boolean {
  return useFeatureFlagValue(FeatureFlag.EnableSplitCostingClusteredReport);
}
